<div [ngClass]="{ 'black-panel': openFilter, panel: !openFilter, 'panel-no-submenu': !openFilter }">
  <mat-expansion-panel class="mat-elevation-z8 filter-position" [attr.expanded]="openFilter" (opened)="openEvent()" (closed)="closeEvent()">
    <mat-expansion-panel-header class="filt-custom">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-9">
            <mat-chip-list>
              <mat-chip *ngFor="let f of filtersMap">{{ f.filter }}</mat-chip>
            </mat-chip-list>
          </div>
          <div class="col-md-2">
            <mat-panel-title class="filter-title">
              Filters
            </mat-panel-title>
          </div>
        </div>
      </div>
    </mat-expansion-panel-header>

    <div class="row filters-row">
      <form [formGroup]="filterForm" (submit)="onSubmitFilter()">
        <div class="col-md-12 text-blue margin-top-5 border-bottom-orange">
          <div class="row">
            <div class="col-md-2">
              <mat-form-field>
                <input matInput formControlName="po" placeholder="PO" />
              </mat-form-field>
            </div>

            <div class="col-md-2">
              <mat-form-field>
                <input matInput formControlName="ean" placeholder="EAN" />
              </mat-form-field>
            </div>

            <div class="col-md-2">
              <mat-form-field class="small-mat-form-field">
                <input matInput type="number" formControlName="unitCostFrom" placeholder="Cost from" />
              </mat-form-field>
              <mat-form-field class="small-mat-form-field margin-left-10">
                <input matInput type="number" formControlName="unitCostTo" placeholder="Cost to" />
              </mat-form-field>
            </div>

            <div class="col-md-2">
              <mat-form-field class="small-mat-form-field">
                <input matInput formControlName="latestDateFrom" [matDatepicker]="dateFrom" placeholder="Latest date from" />
                <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                <mat-datepicker #dateFrom></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="small-mat-form-field margin-left-10">
                <input matInput formControlName="latestDateTo" [matDatepicker]="dateTo" placeholder="Latest date to" />
                <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                <mat-datepicker #dateTo></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-md-2 checkbox-small-text">
              <mat-checkbox formControlName="hasOrderedQuantity">Ordered > 0</mat-checkbox>
            </div>

            <div class="col-md-2 checkbox-small-text">
              <mat-checkbox formControlName="obsoleteWithAccepted">Obsolete with accepted</mat-checkbox>
            </div>
          </div>
        </div>

        <div class="col-md-12 border-top-white">
          <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-2 center">
              <button type="submit" class="box-shadow-none btn-custom" style="float: right;">Filter</button>
            </div>
            <div class="col-md-2 center">
              <button type="button" (click)="resetFilters()" class="box-shadow-none btn-custom">Reset</button>
            </div>
            <div class="col-md-4"></div>
          </div>
        </div>
      </form>

      <mat-divider></mat-divider>
    </div>
  </mat-expansion-panel>
</div>
